
// today
const minDateNow = () => {
  let isNow = new Date()
  let month = isNow.getMonth() + 1
  let day = isNow.getDate()
  let today = isNow.getFullYear() + '-' + (('' + month).length < 2 ? '0' : '') + month + '-' + day
  return today
}

// 30 days after
const maxDateNow = () => {
  let beforedate = new Date()
  let priordate = new Date()
  priordate.setDate(beforedate.getDate() + 90)
  let dd2 = priordate.getDate()
  let mm2 = priordate.getMonth() + 1
  let yyyy2 = priordate.getFullYear()
  if (dd2 < 10) { dd2 = '0' + dd2 };
  if (mm2 < 10) { mm2 = '0' + mm2 };
  let datefrommonthago = yyyy2 + '-' + mm2 + '-' + dd2

  return datefrommonthago
}

export default () => ({
  publishedOnPreview: false,
  cancelOnPreview: false,
  publishing: false,
  disabledPublish: false,
  disabledSave: false,
  show: false,
  beenUpdated: false,
  wasRaised: false,
  showModal: false,
  showModalPreview: false,
  schedules: [],
  agendaTitle: '',
  includes: ['agenda', 'schedulings'],
  optionsAgendas: [],
  date: new Date(),
  config: {
    minDate: minDateNow(),
    maxDate: maxDateNow(),
    sideBySide: true,
    useCurrent: false,
    locale: 'pt-br',
    format: 'DD/MM/YYYY',
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  },
  configEdit: {
    sideBySide: true,
    useCurrent: false,
    locale: 'pt-br',
    format: 'DD/MM/YYYY',
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  }
})



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/form/resources/data.js